// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_80dad68","skeleton":"_65b6939","list":"_6c6875b","grid":"_2d01c09","footer":"_ba7dd84","tile":"_d55515f","imgContainer":"_0e2fd8c"};